/* eslint-disable eqeqeq */
// api returns cents, display dollars.. may include a comma in the near future :)
export const formatCents = function (cents) {
    return Number(cents / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
    })
}

export const formatDollars = (dollars) => {
    return Number(dollars).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
    })
}

// returns an iso date
export const dateToISO8601 = function (date) {
    return new Date(date).toISOString()
}

// returns an iso duration
export const durationToISO8601 = function (duration) {
    const ms = getMinutesSeconds(duration)
    return `T${ms.minutes}M${ms.seconds}S`
}

// converts a duration(sec) into a zero padded wall clock ##:##
export const durationToClock = function (duration) {
    const ms = getMinutesSeconds(duration)

    if (ms.minutes < 10) ms.minutes = `0${ms.minutes}`
    if (ms.seconds < 10) ms.seconds = `0${ms.seconds}`

    return `${ms.minutes}:${ms.seconds}`
}

// 1 product, 0 products, 2 products
export const numberize = function (count, word) {
    return `${count} ${word}${count == 1 ? '' : 's'}`
}

export const plural = function (count, multiple = 's', single = '') {
    return count == 1 ? single : multiple
}

// returns an obj with the minutes/seconds for a duration
function getMinutesSeconds(duration) {
    const minutes = parseInt(duration / 60)
    const seconds = duration - minutes * 60

    return { minutes, seconds }
}
